import { CurrencyInterface } from "../CurrencyInterface";
import { Currency } from "../Currency";
import Translator from "../../Translation/Translator";

class EUR extends Currency implements CurrencyInterface  {

  public static currencyId: number = 1;
  protected symbol: string = "€";
  protected iso: string = "EUR";

  public getName(): string {
    return Translator.trans("currency-eur");
  }

  public getSymbol(): string {
    return this.symbol;
  }

  public getIso(): string {
    return this.iso;
  }
}

export { EUR };
